export const isLoading = ($button) => {
  return $button.is(":disabled");
};
export const setLoading = ($fields, loading) => {
  $fields.forEach(($field) => {
    if (loading) {
      $field.attr("disabled", "disabled");
    } else {
      $field.removeAttr("disabled");
    }
  });
};
